<template>
  <div id="themes_top" :class="{mobile:$vuetify.breakpoint.xs}">
      <ThemesBar />
      <TaskView class="task-view" :class="{mobile:$vuetify.breakpoint.xs}" v-if="current || themes[0]"/>
  </div>
</template>

<script>
    // horizontal scroll
    import ThemesBar from './ThemesBar'
    import TaskView from './tasks/TaskView'
    import { mapState, mapActions, mapGetters, mapMutations } from 'vuex'
    import {isURL, getPubFromURL} from '../../helpers'
    import helperMixin from '../../helpers/mixin'

    export default {
        name: 'Themes',
        data() {
          return {

          }
        },
        components: {
            ThemesBar,
            TaskView,
        },      
        mixins: [helperMixin],
        computed:{
          ...mapGetters(['current', 'themes']),
		
        },      
        methods:{
          ...mapMutations(['SET_CURRENT_BY_ROUTE']),

        },
        mounted() {
          
        },
    }
</script>

<style lang="scss" scoped>
  #themes_top{     
    width: 100%;
    // overflow: hidden;
    background: transparent;
    &.mobile{
      padding: 0px 0px 0px;     
    }     
  }
  .task-view{
    // padding: 64px 0px 0px; 
    &.mobile{
      padding: 0; 
    }    
  }  
</style>

<style>

</style>
